import {kp_copy_notice} from "./kp-helpers";

jQuery(function ($) {
    /* navigation */
    $('.mobile-nav-toggle').on('click', function () {
        $('body').toggleClass('menu-open');
        $('.mobile-nav').addClass('menu-open');
        $('.mobile-nav').removeClass('menu-close');

        if ($('body').hasClass('menu-open')) {
            $('html > body').height($(window).height());
        } else {
            $('.mobile-nav').addClass('menu-close');
            $('.mobile-nav .sub-menu').removeClass('show');
        }
    })

    $('.mobile-nav li.menu-item-has-children > a').on('click', function (e) {
        e.preventDefault();
        $(this).parent().find('.sub-menu').addClass('show');
    })

    $('.mobile-nav li > a[href*="#"], .main-nav li a[href*="#"]').on('click', function (e) {
        e.preventDefault();
    })

    $('.mobile-nav .nav-menu > li.menu-item-has-children > .sub-menu').each(function () {
        var link = '<li><a href="#" class="back-to-main">Back to main menu</a></li>';
        $(this).append(link);

        bindBackTo();
    })

    if ($(window).width() < 768) {
        $('#accordion--lesson-list .tab-content .ld-expand-button').removeClass('ld-expanded')
    }

    $('.expand-video').on('click', function () {
        $('.learndash_post_sfwd-topic').toggleClass('expand-video-content');
        let width = $('.flowplayer').width();
        $('.flowplayer').width(width * 2);
        $('.flowplayer').height('auto');
    })

    function bindBackTo() {
        $('.back-to-main').on('click', function (e) {
            e.preventDefault();
            $(this).parents('.sub-menu').removeClass('show');
        });
    }

    $('.convince-my-boss').on('click', function () {
        var message = 'Hi [Insert Manager\'s Name],\n\n' + 'As you know there have been major changes in analytics with the end of Google\'s Universal Analytics (UA) and the rollout of Google Analytics 4 (GA4). The tracking process in GA4 has completely transformed, as well as the interface and terminology.\n\n' + 'I\'ve found an online course that not only covers the changes in GA4, but offers a comprehensive curriculum on building and implementing an effective analytics system. This course will equip our team with a much stronger analytics foundation and help us better serve our clients with superior data and reporting.\n\n' + 'The course is called Analytics for Agencies and it offers an in-depth look at GA4, Looker Studio, and Google Tag Manager. There are over [X] modules on topics like:\n\n' + 'How to setup up triggers, tags, and custom events\n' + 'Effective goal setting with clients\n' + 'Creating custom reports and dashboards\n' + 'Consent management, privacy laws and cookies, and so much more\n\n' + 'The course was created for agency teams and will help us streamline our approach to analytics, provide our team with effective training, and give us the skills needed to plan, set up, analyze and optimize data-driven marketing strategies for our clients.\n\n' + 'The training costs [$599 USD] per person, which is substantially less than most conference tickets (if we enroll additional team members there is a discount blah blah blah). In addition to the lessons, the course also includes production ready resources that we can implement in our analytics process, an online community and regular office hours to ask implementation questions, and a certification upon completion.\n\n' + 'Let me know if I can go ahead and enroll myself and/or the rest of the team in the course. I would be happy to provide you with more information on the course, its curriculum, and additional benefits, if needed. Thank you for your time and consideration.\n\n' + 'Best,\n\n' + '[Your Name]\n' + '[Your Position]\n' + '[Your Department]\n' + '[Your Company]';
        navigator.clipboard.writeText(message).then(function () {
            //alert('It worked! Do a CTRL - V to paste')
            $('.copied-flag').css('opacity', '1');
            setTimeout(function () {
                $('.copied-flag').css('opacity', '0');
            }, 3000);
        }, function () {
            alert('Failure to copy. Check permissions for clipboard')
        });


    })

    /* Newsletter */
    $('.newsletter-overlay').on('click', function () {
        close_newsletter();
    })

    $(".newsletter-close").on("click", function (e) {
        e.preventDefault();
        close_newsletter();
    })

    $(".newsletter-btn").on("click", function (e) {
        e.preventDefault();
        open_newsletter();
    })

    function open_newsletter() {
        $(".newsletter-drawer").addClass('open');
        $('body').addClass('overlay-open');
    }

    function close_newsletter() {
        $(".newsletter-drawer").removeClass('open');
        $('body').removeClass('overlay-open');
    }

    $('a[href*="#newsletter"]').on('click', function (e) {
        e.preventDefault();
        open_newsletter();
    })

    // Hash Scroll
    $('a[href^="#"]:not([href="#newsletter"])').not('.newsletter-btn').not('.external-link').not('.pagination a').not('.mobile-nav a')
        .not('.main-nav a').not('#menu-utility-menu a').not('.not-hash-scroll').on('click', function (e) {
        e.preventDefault();
        var target = $(this.hash);
        if (!target.offset()) return false;
        var scroll = target.offset().top;
        var currentPos = $(window).scrollTop();
        var direction;

        if (currentPos < scroll) {
            direction = 'down';
        } else {
            direction = 'up';
        }
        //console.log(currentPos)
        //console.log(scroll)

        if ($('.site-header').length > 0 && direction == 'up')
            scroll = scroll - parseInt($('.site-header').outerHeight());

        if ($('#wpadminbar').length > 0)
            scroll = scroll - parseInt($('#wpadminbar').outerHeight());

        if ($(this).data('offset') && $(this).data('offset') != undefined)
            scroll = scroll - $(this).data('offset');

        $('html, body').animate({
            scrollTop: scroll
        }, 800);
    });

    // TOC toggle
    $('.toc-sidebar .sidebar-header').on('click', function () {
        $('.toc-sidebar').toggleClass('show');
    })

    // auto resize youtube embeds

    const videos = document.querySelectorAll('iframe[src*="youtube"]')
    videos.forEach(video => {

        const width = video.getAttribute('width')
        const height = video.getAttribute('height')

        if (width && height) {
            const ratio = height / width;
            const wrapper = document.createElement('div');
            video.style.position = 'absolute'
            video.setAttribute('width', '100%')
            video.setAttribute('height', '100%')
            wrapper.style.width = '100%'
            wrapper.style.paddingBottom = `${Math.round(ratio * 100)}%`
            wrapper.style.position = 'relative'
            wrapper.appendChild(video.cloneNode(true));
            video.replaceWith(wrapper);
        }
    })

    // auto open newsletter drawer if directly linked
    const hash = window.location.hash
    if (hash === '#newsletter') {
        open_newsletter()
    }

    // back to top button
    const backToTopBtn = document.querySelector('.back-to-top-btn')
    if (backToTopBtn) {
        backToTopBtn.addEventListener('click', e => {
            e.preventDefault()
            window.scrollTo({top: 0, behavior: 'smooth'});
        })
        window.addEventListener('scroll', (e) => {
            const top = window.innerHeight / 4
            const bottom = document.body.scrollHeight - window.innerHeight - (window.innerHeight / 4)
            if (window.scrollY > top && window.scrollY < bottom) {
                backToTopBtn.classList.add('opacity-100')
                backToTopBtn.classList.remove('pointer-events-none')
                backToTopBtn.classList.remove('opacity-0')
            } else {
                backToTopBtn.classList.remove('opacity-100')
                backToTopBtn.classList.add('pointer-events-none')
                backToTopBtn.classList.add('opacity-0')
            }
        })
    }

    $.widget("ui.autocomplete", $.ui.autocomplete, {
        _close: function (event) {
            if (event !== undefined && event.keepOpen === true) {
                return false;
            }
            return this._super(event);
        },
        _create: function () {
            this._super();
            this.widget().menu("option", "items", "> :not(.ui-autocomplete-category)");
        },
        _renderMenu: function (ul, items) {
            let that = this,
                currentCategory = "";
            $.each(items, function (index, item) {
                let li;
                if (item.module != currentCategory) {
                    ul.append("<li class='ui-autocomplete-category'>" + item.module + "</li>");
                    currentCategory = item.module;
                }
                li = that._renderItemData(ul, item);
                if (item.module) {
                    li.attr("aria-label", item.module + " : " + item.label);
                }
            });
        }
    });


    $('#lesson-autocomplete').autocomplete({
        delay: 0,
        source: window.kpa.ld_lessons,
        select: function (event, ui) {
            window.location = ui.item.value
            $.extend(event.originalEvent, {keepOpen: true});
            return false;
        },
        open: function (event, ui) {
            $(this).autocomplete("widget").css({"width": ($(this).css("width"))});
        },
    });

    updateAnnouncementBarHeight()


    $( window ).on( "resize", function() {
        updateAnnouncementBarHeight()
    } );

})

// header scroll animation
var scroll_pos = 0;
var last_scroll_pos = 0;
var ticking = false;
var down_scroll_pos_trigger = 130;
var up_scroll_pos_trigger = 75;

var staggered_content = document.querySelectorAll('.block--staggered-fade-in-content');

function updateAnnouncementBarHeight(value) {
    const announcement_bar = document.querySelector('header .announcement-bar');
    if (announcement_bar) {
        if (value === undefined) {
            value = announcement_bar.offsetHeight
        }
        document.querySelector('body').style.setProperty("--announcement-height", `${value}px`);
    }
}

function staggeredContent() {
    var staggered_content = document.querySelectorAll('.staggered-item');
    var window_bottom = window.scrollY + window.innerHeight;
    var offset = 250;

    var length = staggered_content.length;
    for (i = 0; i < length; i++) {
        if (window_bottom > staggered_content[i].offsetTop + offset) {
            staggered_content[i].classList.add('reveal');
        }
    }
}

var timeline_content = document.querySelectorAll('.block--timeline');
var timeline_events = document.querySelector('timeline-block');

function timelineAnimation() {
    for (var i = 0; i < timeline_events.length; i++) {
        if (isElementInViewport(timeline_events[i])) {
            timeline_events[i].classList.add("in-view");
        }
    }
}


const fade_observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('in-view')
            observer.unobserve(entry.target)
        }
    })
}, {
    threshold: .1
})

const fade_in_content = document.querySelectorAll('.kp-fade-in-animation');
fade_in_content.forEach(block => {
    fade_observer.observe(block)
})


var course_highlights = document.querySelectorAll('.block--course-highlights .highlight:not(:first-of-type)');

course_highlights.forEach(block => {
    fade_observer.observe(block)
})


function animateMenu(scroll_pos, direction) {
    var body_el = document.querySelector('html > body');
    var wrapper_nav = document.querySelector('.site-header');

    if (scroll_pos > down_scroll_pos_trigger && !wrapper_nav.classList.contains('scrolling-down') && direction === 'down') {
        wrapper_nav.classList.add('scrolling-down');
        wrapper_nav.classList.remove('scrolling-up');

        body_el.classList.add('scrolling-down');
        body_el.classList.remove('scrolling-up');
    } else if (direction === 'up' && !wrapper_nav.classList.contains('scrolling-up')) {
        wrapper_nav.classList.add('scrolling-up');
        wrapper_nav.classList.remove('scrolling-down');

        body_el.classList.add('scrolling-up');
        body_el.classList.remove('scrolling-down');
    }

    if (scroll_pos < up_scroll_pos_trigger) {
        wrapper_nav.classList.remove('scrolling-up');
        wrapper_nav.classList.remove('scrolling-down');
        document.querySelector('body').classList.remove('scrolling');
    }

    if (scroll_pos > down_scroll_pos_trigger) {
        document.querySelector('body').classList.add('scrolling');
    }
}

window.addEventListener('scroll', handleScroll, {passive: true});

function handleScroll() {
    scroll_pos = window.scrollY;
    if (!ticking) {
        window.requestAnimationFrame(function () {
            //direction = getDirection(scroll_pos, last_scroll_pos);

            if (timeline_content.length > 0)
                timelineAnimation(scroll_pos);

            if (staggered_content.length > 0)
                staggeredContent(scroll_pos);

            ticking = false;
            last_scroll_pos = scroll_pos;
        });

        ticking = true;
    }
}

function getDirection(scroll_pos, last_scroll_pos) {
    if (scroll_pos > last_scroll_pos) {
        return 'down';
    } else if (scroll_pos < last_scroll_pos) {
        return 'up';
    }
}

function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

const close_announcement_btn = document.querySelector('#close-announcement');
if (close_announcement_btn) {
    close_announcement_btn.addEventListener('click', () => {
        set_cookie('closed_announcement', 1, 1);
        document.body.classList.add('hide-announcement');
        updateAnnouncementBarHeight(0)
    })
}

const closed_announcement = get_cookie('closed_announcement')
if (closed_announcement !== '1') {
    document.body.classList.remove('hide-announcement');
}

const close_newsletter_banner_btn = document.querySelector('#close-newsletter-banner');
if (close_newsletter_banner_btn) {
    close_newsletter_banner_btn.addEventListener('click', () => {
        set_cookie('closed_newsletter_banner', 1, 7);
        document.body.classList.add('hide-newsletter-banner');
    })
}

const closed_newsletter_banner = get_cookie('closed_newsletter_banner')
if (closed_newsletter_banner !== '1') {
    document.body.classList.remove('hide-newsletter-banner');
}

const newsletter_banner_bar = document.querySelector('#newsletter-banner-bar');
if (newsletter_banner_bar) {
    window.addEventListener('scroll', (e) => {
        const top = window.innerHeight / 4
        const bottom = document.body.scrollHeight - window.innerHeight - (window.innerHeight / 4)
        if (window.scrollY < bottom) {
            newsletter_banner_bar.classList.add('opacity-100')
            newsletter_banner_bar.classList.remove('pointer-events-none')
            newsletter_banner_bar.classList.remove('opacity-0')
        } else {
            newsletter_banner_bar.classList.remove('opacity-100')
            newsletter_banner_bar.classList.add('pointer-events-none')
            newsletter_banner_bar.classList.add('opacity-0')
        }
    })
}

const url_params = new URLSearchParams(window.location.search);
const subscriber_param = url_params.get('ck_subscriber_id')
if ( subscriber_param ) {
    set_cookie('ck_subscriber_id', subscriber_param, 7);
    set_cookie('closed_newsletter_banner', 1, 7);
    document.body.classList.add('hide-newsletter-banner');
    newsletter_banner_bar.classList.add('hidden')
}


function set_cookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function get_cookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

// Datalayer Pushes
window.dataLayer = window.dataLayer || []
const accordions = document.querySelectorAll('.block--accordion, #accordion--course-content')
const contentBoxes = []
window.dataLayer = window.dataLayer || []
accordions.forEach(a => {
    const items = a.querySelectorAll('.accordion-item')
    items.forEach(item => {
        const input = item.querySelector('input')
        const content = item.querySelector('.tab-content')
        contentBoxes.push(content)
        input.addEventListener('click', e => {
            if (e.target.checked) {
                content.style.maxHeight = `${content.scrollHeight}px`
            } else {
                content.style.maxHeight = 0;
            }
            if (e.target.parentNode.querySelector('h3')) {
                window.dataLayer.push({
                    'event': 'accordion',
                    'accordion_item': e.target.parentNode.querySelector('h3').innerText
                })
            }
        })

    })
})

window.addEventListener('resize', e => {
    contentBoxes.forEach(box => {
        const newHeight = `${box.scrollHeight}px`
        if (box.offsetHeight > 0 && box.style.maxHeight !== newHeight) {
            box.style.maxHeight = newHeight
        }
    })
})


const code_blocks = document.querySelectorAll('code')
code_blocks.forEach(block => {
    const code = block.innerHTML
    const copy_btn = document.createElement('div');
    copy_btn.classList.add('copy-btn')
    copy_btn.addEventListener('click', e => {
        e.preventDefault()
        navigator.clipboard.writeText(code).then(() => {
            kp_copy_notice(block)
        });
    })
    block.append(copy_btn)
})

setTimeout(() => {
    document.querySelectorAll('input.learndash_mark_complete_button').forEach(button => {
        button.disabled = false
    });
}, 1000)

const seats_select = document.querySelector('#course-team-seats')
const team_price = document.querySelector('#course-team-price')
const team_enroll_btn = document.querySelector('#team-enroll-btn')
if (seats_select && team_price) {

    const base_price = parseFloat(seats_select.dataset.price)
    seats_select.addEventListener('change', (e) => {
        const select = e.currentTarget
        const discount = parseFloat(select.options[select.selectedIndex].dataset.discount)
        team_price.innerHTML = Math.round(base_price * discount)
        if (team_enroll_btn) {
            const href = team_enroll_btn.getAttribute('href')
            const url = new URL(href)
            url.searchParams.set('qty', select.options[select.selectedIndex].value)
            team_enroll_btn.setAttribute('href', url.toString())
        }
    })
}

if (window.location.pathname === '/analytics-for-agencies/' && window.location.hash === '#officehours') {
    window.location.href = '/my-account/?redirect=/courses/analytics-for-agencies/#officehours'
}

const parity_pricing = document.querySelector('.parity-pricing')
if ( parity_pricing ) {
    setTimeout( () => {
        parity_pricing.classList.add('bottom-0')
    }, 3000)

    parity_pricing.querySelector('.parity-close').addEventListener('click', ()=> {
        console.log('close parity')
        parity_pricing.classList.remove('bottom-0')
    })
}
